<template>

    <div class="col-md-12 switch-right-list" v-if="hintVisible">
      <p class="gray-dark">{{'protocol.hint_sub_title' | trans}}</p>
      <div class="row">
        <div class="col-md-12 hint-wrapp">

          <mdc-switch  v-for="hint in sortedHintList" :key="hint.id" v-model="hint.active" :class="{'pl-4' : hint.subLevel}">
            <span class="color-block" :style="{background: hint.color}">{{hint.title}}</span>
            {{hint.description}}
          </mdc-switch>

        </div>
      </div>
    </div>


</template>

<script>
  import cloneDeep from 'lodash/cloneDeep';

  export default {
    name: 'HintList',

    props: {
      hintList: [Object, Array],
      hintVisible: false
    },

    computed: {
      sortedHintList() {
        let promts = this.hintList;

        promts[2].subLevel=true;
        promts[3].subLevel=true;
        promts[4].subLevel=true;
        promts[5].subLevel=true;
        
        if (this.hintList[2].active || this.hintList[3].active || this.hintList[4].active || this.hintList[5].active){
          promts[1].active = true;
        }
        
        return promts
      }
    },

    


  };
</script>


// WEBPACK FOOTER //
// src/modules/protocols/components/Hints.vue